(function () {
  'use strict';

  function syncContainer(container) {
    var expanded = container.classList.contains('lop-filter-values--expanded');
    var hiddenItems = container.querySelectorAll('.lop-filter-values__item--hidden');

    hiddenItems.forEach(function (item) {
      if (expanded) {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', '');
      }
    });
  }

  function initContainers(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.lop-filter-values--collapsible');

    containers.forEach(function (container) {
      if (!container.classList.contains('lop-filter-values--expanded')) {
        syncContainer(container);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.lop-filter-values__toggle');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    var container = toggle.closest('.lop-filter-values');
    if (!container) return;

    var expanded = container.classList.toggle('lop-filter-values--expanded');
    syncContainer(container);

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Ver menos' : 'Ver más';
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initContainers();
    });
  } else {
    initContainers();
  }

  if (window.xoFilters && typeof window.xoFilters.on === 'function') {
    window.xoFilters.on('done', function () {
      initContainers();
    });
  }
})();
